/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Load_Project_File_Status_Loading_YoutubeInputs */

const en_load_project_file_status_loading_youtube = /** @type {(inputs: Load_Project_File_Status_Loading_YoutubeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Loading YouTube Video...`)
};

const fr_load_project_file_status_loading_youtube = /** @type {(inputs: Load_Project_File_Status_Loading_YoutubeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chargement de la video YouTube...`)
};

const de_load_project_file_status_loading_youtube = /** @type {(inputs: Load_Project_File_Status_Loading_YoutubeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`YouTube-Video wird geladen...`)
};

const it_load_project_file_status_loading_youtube = /** @type {(inputs: Load_Project_File_Status_Loading_YoutubeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Caricamento video di YouTube...`)
};

const ru_load_project_file_status_loading_youtube = /** @type {(inputs: Load_Project_File_Status_Loading_YoutubeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Загрузка видео с YouTube...`)
};

const es_load_project_file_status_loading_youtube = /** @type {(inputs: Load_Project_File_Status_Loading_YoutubeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cargando vídeo de YouTube...`)
};

const zh_cn2_load_project_file_status_loading_youtube = /** @type {(inputs: Load_Project_File_Status_Loading_YoutubeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`正在加载 YouTube 视频...`)
};

const ja_load_project_file_status_loading_youtube = /** @type {(inputs: Load_Project_File_Status_Loading_YoutubeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`YouTube ビデオを読み込んでいます...`)
};

const hi_load_project_file_status_loading_youtube = /** @type {(inputs: Load_Project_File_Status_Loading_YoutubeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`यूट्यूब वीडियो लोड हो रहा है...`)
};

const pt_pt2_load_project_file_status_loading_youtube = /** @type {(inputs: Load_Project_File_Status_Loading_YoutubeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Carregando vídeo do YouTube...`)
};

/**
* | output |
* | --- |
* | "Loading YouTube Video..." |
*
* @param {Load_Project_File_Status_Loading_YoutubeInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const load_project_file_status_loading_youtube = /** @type {((inputs?: Load_Project_File_Status_Loading_YoutubeInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Load_Project_File_Status_Loading_YoutubeInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_load_project_file_status_loading_youtube(inputs)
	if (locale === "de") return de_load_project_file_status_loading_youtube(inputs)
	if (locale === "it") return it_load_project_file_status_loading_youtube(inputs)
	if (locale === "ru") return ru_load_project_file_status_loading_youtube(inputs)
	if (locale === "es") return es_load_project_file_status_loading_youtube(inputs)
	if (locale === "zh-CN") return zh_cn2_load_project_file_status_loading_youtube(inputs)
	if (locale === "ja") return ja_load_project_file_status_loading_youtube(inputs)
	if (locale === "hi") return hi_load_project_file_status_loading_youtube(inputs)
	if (locale === "pt-PT") return pt_pt2_load_project_file_status_loading_youtube(inputs)
	return en_load_project_file_status_loading_youtube(inputs)
});